import axios from 'axios'
import React from 'react'
import { apiUrl } from './config'

const userModule = {
    createUser : async (body) =>{
        return  axios.post(`${apiUrl}/create-user`, body)

    },
    checkUserDeative : async (body) =>{
        return  axios.post(`${apiUrl}/meeting-Assigned-count`, body)
    },
    ResignMeeting : async (body) =>{
        return  axios.post(`${apiUrl}/change-assignee`, body)
    }
}

export default userModule